// ******************************************
// register components


import './translate25localeLoaderVconsole.mjs'

import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'

import ChangeLocale from './ChangeLocale.vue'

declareVconsoleComponent('changeLocale', ChangeLocale, 'translate25:vconsole17:changelocale:upthere')